import { defineVariants } from "@/runtime/style-engine/define-variants";

export const toasterClasses = defineVariants({
  base: "fixed z-[999] pointer-events-none flex",
  variants: {
    position: {
      "top-left": "top-0 left-0 flex-col",
      "top-center": "top-0 left-1/2 -translate-x-1/2 flex-col items-center",
      "top-right": "top-0 right-0 flex-col items-end",
      "bottom-left": "bottom-0 left-0 flex-col-reverse",
      "bottom-center": "bottom-0 left-1/2 -translate-x-1/2 flex-col-reverse items-center",
      "bottom-right": "bottom-0 right-0 flex-col-reverse items-end",
    },
  },
  defaults: {
    position: "bottom-right",
  },
});
